import type { ReactNode } from 'react'
import type { TFunction } from 'i18next'
import useModuleCollapse from '@/containers/SubscriptionFormPageNew/Components/shared/ModuleCollapse/useModuleCollapse'
import useModuleNotifications from '@/containers/SubscriptionFormPageNew/Components/shared/RightPanel/useModuleNotifications'
import useCreditBooster from './useCreditBooster'
import { type CreditBoosterSale, orderQuests, orderSegments } from './orderSales'

export interface CreditBoosterQuest extends CreditBoosterSale {
  hint: string | null
  iconNode: ReactNode
  onOpen: () => void
}

interface UseCreditBoosterContentParams {
  t: TFunction
  scriptArray: CreditBoosterSale[]
  onOpenSale: (saleName: string) => void
}

const useCreditBoosterContent = ({ t, scriptArray, onOpenSale }: UseCreditBoosterContentParams) => {
  const { getIcon, contactId, existingSalesLoaded } = useCreditBooster()
  const { expanded, toggle, panelExpanded } = useModuleCollapse('credit-booster')

  useModuleNotifications({
    moduleKey: 'credit-booster',
    scope: contactId,
    loaded: existingSalesLoaded,
    items: scriptArray.map(sale => `${sale.name}:${sale.sold ? 'sold' : 'open'}`),
    visible: expanded,
  })

  const quests: CreditBoosterQuest[] = orderQuests(scriptArray).map(sale => ({
    ...sale,
    hint: sale.sold ? t('subscriptionForm:credit_booster.done') : null,
    iconNode: getIcon(sale.icon, sale.sold),
    onOpen: () => onOpenSale(sale.name),
  }))

  const soldCount = scriptArray.filter(sale => sale.sold).length

  return {
    expanded,
    toggle,
    panelExpanded,
    soldCount,
    saleCount: scriptArray.length,
    completed: soldCount === scriptArray.length,
    quests,
    segments: orderSegments(scriptArray),
    addLabel: t('subscriptionForm:credit_booster.add_button'),
  }
}

export default useCreditBoosterContent
